import { render, staticRenderFns } from "./AllowedMethods.vue?vue&type=template&id=0dfd87f6&lang=pug"
import script from "./AllowedMethods.vue?vue&type=script&lang=js"
export * from "./AllowedMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SurveyHideNextCompleteStyle: require('/home/docker/code/frontend/components/survey/HideNextCompleteStyle.vue').default})
